module.exports = __webpack_public_path__ + "media/app/assets/races/highmountain_tauren_male-021f5e408fc140e377f219354c3db257.png";